export type ClassNamable = string | number | Record<string, boolean> | boolean | null | undefined;

function toString(value: ClassNamable | ClassNamable[]) {
  let str = '';

  if (typeof value === 'string' || typeof value === 'number') {
    str += value;
  } else if (typeof value === 'object') {
    if (Array.isArray(value)) {
      const length = value.length;
      for (let k = 0; k < length; k++) {
        if (value[k]) {
          const val = toString(value[k]);
          if (val) {
            if (str) str += ' ';
            str += val;
          }
        }
      }
    } else {
      for (const y in value) {
        if (value[y as keyof typeof value]) {
          if (str) str += ' ';
          str += y;
        }
      }
    }
  }

  return str;
}

export function cn(...classNames: (ClassNamable | ClassNamable[])[]): string {
  let str = '';

  for (let i = 0; i < classNames.length; i++) {
    const tmp = classNames[i];
    if (tmp) {
      const val = toString(tmp);
      if (val) {
        if (str) str += ' ';
        str += val;
      }
    }
  }

  return str;
}
